.title {
    margin: 1rem 1rem;
    color: var(--color-blue-800);
}
